module.exports = __webpack_public_path__ + "img/igm.8df95c6b.png";